import { ToastParams } from "types/toast";
import useToastStore from "stores/toastStore";

const ToastBridge = {
    add: (payload: ToastParams) => {
        useToastStore.getState().add(payload);
    }
};

export default ToastBridge;